const BROADCAST = 'my_broadcast_event';
const ROOM_MESSAGE = 'my_room_event';
const RESPONSE = 'my_response';

export default {
  BROADCAST,
  ROOM_MESSAGE,
  RESPONSE,
};
